import { Alert, AlertDescription, AlertTitle } from '@nesso/ui/primitives/alert';

import { SUPPORT_EMAIL } from '@/shared/constants/support';
import { StatusIcon } from '@/shared/ui/common/status-icon';
import { CardFormSection } from '@/shared/ui/forms/card-form-section';

import { useDashboardSetup } from '../../../../model/use-dashboard-setup';
import { OnboardingDashboardSetupStepIcon } from './onboarding-dashboard-setup-step/onboarding-dashboard-setup-step-icon';

const STEPS = [
    'Building your dashboard',
    'Configuring your notes',
    'Preparing client profile',
] as const;

export function OnboardingDashboardSetupStep() {
    const { statuses, isError } = useDashboardSetup();

    return (
        <div className="flex flex-col items-center pt-12 sm:pt-3.5 space-y-6">
            {isError && (
                <div className="px-4 md:px-0 w-full md:w-162.5">
                    <Alert variant="destructive" className="mt-0">
                        <AlertTitle>Unable to create your dashboard</AlertTitle>
                        <AlertDescription>
                            <span>
                                Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> for
                                assistance
                            </span>
                        </AlertDescription>
                    </Alert>
                </div>
            )}
            <CardFormSection
                variant="centered"
                className="mt-0 sm:mt-0"
                title="Sit back and relax while we customize your experience"
                titleIcon={<OnboardingDashboardSetupStepIcon />}
                cardTitleClassName="text-2xl"
                cardContentClassName="sm:pt-12 sm:pb-14.5"
                showBackButton={false}
                showNextButton={false}
            >
                <div className="flex flex-col gap-6 sm:gap-4 max-w-52.5 mx-auto">
                    {STEPS.map((label, i) => (
                        <div key={label} className="flex gap-2 items-center">
                            <StatusIcon status={statuses[i]} />
                            <div>{label}</div>
                        </div>
                    ))}
                </div>
            </CardFormSection>
        </div>
    );
}
